import * as r from 'ramda';
import * as ra from 'ramda-adjunct';
import { useSelector } from 'react-redux';
import classnames from 'classnames/bind';
import styles from './MainLayout.module.css';

import * as $auth from 'modules/auth';

import { StickiesLogo } from 'view/components/common/StickiesLogo';
import { Header } from 'view/components/app/Header/Header';
import { MENU_ITEMS } from './menuItems';
import { MenuItem } from './MenuItem';

const cls = classnames.bind(styles);

const getAvailableMenuItems = (menuItems, userRoles) =>
  menuItems.filter(({ availableForRoles }) =>
    ra.isNotEmpty(r.intersection(availableForRoles, userRoles))
  );

export const MainLayout = ({ children }) => {
  const currentUserRoles = useSelector($auth.getCurrentUserRoles);

  const availableMainMenuItems = getAvailableMenuItems(MENU_ITEMS, currentUserRoles);

  return (
    <div className={cls('container')}>
      <div className={cls('sidebar')}>
        <StickiesLogo className={cls('logo')} />

        <div className={cls('menu')}>
          {availableMainMenuItems.map(({ name, route, icon, text }) => (
            <MenuItem key={name} route={route} icon={icon} text={text} />
          ))}
        </div>
      </div>

      <div className="flex flex-col w-full">
        <Header className="flex-shrink-0" />

        <div className={cls('content')}>{children}</div>
      </div>
    </div>
  );
};
